module.exports = __webpack_public_path__ + "img/ship.b1adbbbc.svg";